<template>
	<div class="voice-content" :class="{ 'voice-content--self': isSelf }" @click="togglePlay">
		<div class="voice-message" :class="{ 'playing': isPlaying }" :style="{ width: calculatedWidth + 'px' }">
			<div class="voice-wave">
				<div v-for="(bar, index) in waveBars" :key="index" class="wave-bar"
					:style="{ height: `${isPlaying ? bar.height : 4}px` }">
				</div>
			</div>
			<div class="voice-duration">{{ duration }}″</div>
		</div>
		<div class="unread-dot" v-if="msgItem.isRead=='N'"></div>
	</div>
</template>

<script>
	export default {
		props: {
			msgItem: {
				type: Object,
				required: true
			},
			isSelf: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isPlaying: false,
				audioElement: null,
				waveBars: Array(5).fill({
					height: 4
				}),
				animationFrameId: null,
				minWidth: 60,
				maxWidth: 180,
			};
		},
		computed: {
			duration() {
				// 直接使用秒数，不再需要转换
				return this.msgItem.duration;
			},
			calculatedWidth() {
				return this.duration * 3;
			}
		},
		methods: {
			togglePlay() {
				if (this.isPlaying) {
					this.stopPlayback();
				} else {
					this.startPlayback();
					this.$emit('read');
				}
			},
			startPlayback() {
				this.isPlaying = true;
				this.audioElement = new Audio(this.msgItem.content);
				this.audioElement.play();
				this.updateWaveAnimation();

				this.audioElement.onended = () => {
					this.stopPlayback();
				};
			},
			stopPlayback() {
				if (this.audioElement) {
					this.audioElement.pause();
					this.audioElement.currentTime = 0;
					this.audioElement = null;
				}
				this.isPlaying = false;
				if (this.animationFrameId) {
					cancelAnimationFrame(this.animationFrameId);
				}
			},
			updateWaveAnimation() {
				if (!this.isPlaying) return;

				this.waveBars = this.waveBars.map(() => ({
					height: Math.max(4, Math.floor(Math.random() * 12) + 4)
				}));

				this.animationFrameId = requestAnimationFrame(this.updateWaveAnimation);
			}
		},
		beforeDestroy() {
			this.stopPlayback();
		}
	};
</script>
<style lang="less" scoped>
	.voice-content {
		display: flex;
		align-items: center;
		position: relative;

		.voice-message {
			display: flex;
			align-items: center;
			border-radius: 4px;
			transition: all 0.2s;
			min-width: 60px;
			max-width: 180px;

			&.playing {
				opacity: 1;
			}

			.voice-wave {
				display: flex;
				align-items: center;
				height: 24px;
				gap: 3px;

				.wave-bar {
					width: 2px;
					border-radius: 1px;
					transition: height 0.2s ease-out;

					&:nth-child(odd) {
						height: 8px;
					}
				}
			}

			.voice-duration {
				margin-left: 8px;
				font-size: 14px;
				min-width: 20px;
			}
		}

		.unread-dot {
			width: 8px;
			height: 8px;
			background-color: #f44336;
			border-radius: 50%;
			margin-left: 8px;
		}
	}

	/* 自己的：绿色背景、绿色波形 */
	.voice-content--self .voice-message {
		background-color: #95ec69;

		.voice-wave .wave-bar {
			background-color: #07c160;
		}

		.voice-duration {
			color: #666;
		}
	}

	/* 别人的：白底、灰色波形 */
	.voice-content:not(.voice-content--self) .voice-message {
		background-color: #fff;

		.voice-wave .wave-bar {
			background-color: #666;
		}

		.voice-duration {
			color: #333;
		}
	}
</style>